
const FundPurchaseNotAllowed = (props) => {
    return (
        <div style={{height: '200px', lineHeight: '200px', textAlign: 'center'}}>
            {props.text}
        </div>
    );
}
export default FundPurchaseNotAllowed;